import LazyLoad from "react-lazyload";

import "swiper/css/effect-fade";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css";

import Title from "components/atoms/Title";

import CardMakeDifferent from "./CardMakeDifferent";
import WMUDSlider from "./WMUDSlider";

const WhatMakeUsDifferent = ({ data, title, ebookImage, ...props }) => {
  return (
    <div {...props} className={props.className || "bg-wmud py-12 "}>
      {title && (
        <Title
          text={title}
          className="bbc-title mb-10 px-4 text-center lg:px-0"
        />
      )}
      <div className="overflow-hidden">
        <LazyLoad
          classNamePrefix="wmud-lazyload"
          placeholder={
            data.length > 0 &&
            data.map((item, index) => (
              <CardMakeDifferent
                key={index}
                title={item.title}
                description={item.description}
                src={item.img_src}
                width={item.width}
                height={item.height}
                alt={item.img_alt}
                listWithIcon={item.listWithIcon}
              />
            ))
          }
        >
          <WMUDSlider data={data} ebookImage={ebookImage} />
        </LazyLoad>
      </div>
    </div>
  );
};

export default WhatMakeUsDifferent;
